import React from 'react';
import PropTypes from 'prop-types';
import styles from './Input.module.sass'

Input.propTypes = {
    initialValue: PropTypes.string,
    height: PropTypes.oneOf(['small', 'medium', 'large']),
    label: PropTypes.string,
    onChange: PropTypes.func
};

function Input(props) {

    return (
        <div>
            <label className={styles.label} htmlFor={props.id}>{props.label}
                {props.showAttention ? <div className="input-attention fade-in-fwd">{props.attentionText}</div> : ''}
            </label>
            <textarea onChange={props.onChange} id={props.id} className={`${styles.input} ${styles[props.height]}`}
                      defaultValue={props.initialValue}
            />
        </div>

    );
}

export default Input;